import { CALENDAR_EVENT_TYPES } from '@/app/(main)/calendar/consts/calendar-event-types';
import { eventOccursOnCalendarDay } from '@/app/(main)/calendar/utils/eventOccursOnCalendarDay';
import type { CalendarEvent } from '@/types/calendarTypes';

export interface CalendarSummaryGroups {
  events: CalendarEvent[];
  birthdays: CalendarEvent[];
  tasks: CalendarEvent[];
}

export function groupSummaryForDate(events: CalendarEvent[], selectedDate: Date): CalendarSummaryGroups {
  const eventsList: CalendarEvent[] = [];
  const birthdays: CalendarEvent[] = [];
  const tasks: CalendarEvent[] = [];

  for (const event of events) {
    if (!eventOccursOnCalendarDay(event, selectedDate)) continue;
    if (event.type === CALENDAR_EVENT_TYPES.BIRTHDAY) {
      birthdays.push(event);
    } else if (event.type === CALENDAR_EVENT_TYPES.TASK_DEADLINE || event.type === CALENDAR_EVENT_TYPES.TASK_REMINDER) {
      tasks.push(event);
    } else if (
      event.type === CALENDAR_EVENT_TYPES.OUTLOOK_VIRTUAL ||
      event.type === CALENDAR_EVENT_TYPES.OUTLOOK_IN_PERSON
    ) {
      eventsList.push(event);
    }
  }

  return { events: eventsList, birthdays, tasks };
}
